import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApi } from '@core/base/base-api';
import { SearchResult } from '@core/base/objects/search/search-result';
import { Pagination } from '@core/objects/pagination';
import { paginationToHttpParams } from '@core/utils/pagination-utils';
import { TaskExecution } from '@shared/task/task-execution';
import { TaskExecutionSummary } from '@shared/task/task-execution-summary';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TaskExecutionApi extends BaseApi<TaskExecution> {
  constructor(httpClient: HttpClient) {
    super(httpClient, 'tasks/executions');
  }

  create(): TaskExecution {
    return new TaskExecution();
  }

  findFailedTasks(): Observable<TaskExecution[]> {
    return this.httpClient.get<TaskExecution[]>(`${this.endpoint}/failures`);
  }

  summaries(taskExecutionUuid: string, pagination: Pagination): Observable<SearchResult<TaskExecutionSummary>> {
    const httpParams = paginationToHttpParams(pagination);

    return this.httpClient.get<SearchResult<TaskExecutionSummary>>(
      `${this.endpoint}/${taskExecutionUuid}/summaries/v2`,
      {
        params: httpParams,
      },
    );
  }
}
